/**
 * App用フック
 * サイドバー状態とセッション管理を統合
 */

import { useState, useCallback } from 'react';
import { useSessionManagement } from '../../../hooks/useSessionManagement';
import { SessionInitStatus } from '../../../types';
import { useUsageGuide } from '../../../hooks/useUsageGuide';

export const useApp = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const {
    sessionId,
    ageGroup,
    userId,
    initStatus,
    chatHistory,
    loadChatHistory,
    handleNewChat,
    handleSelectChat,
    handleDeleteSession,
  } = useSessionManagement();

  const usageGuide = useUsageGuide(initStatus === SessionInitStatus.READY, userId);

  const handleToggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  const handleCloseSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  return {
    // 状態
    sidebarOpen,
    sessionId,
    ageGroup,
    initStatus,
    chatHistory,

    // ハンドラー
    handleToggleSidebar,
    handleCloseSidebar,
    loadChatHistory,
    handleNewChat,
    handleSelectChat,
    handleDeleteSession,

    // 使い方モーダル
    usageGuide,
  };
};
